"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var app_constants_1 = require("../../../app.constants");
var PasswordResetInitService = /** @class */ (function () {
    function PasswordResetInitService(http) {
        this.http = http;
    }
    PasswordResetInitService.prototype.save = function (form) {
        return this.http.post(app_constants_1.LOGBOOK_API + '/api/password-reset/init', form, { observe: "response" });
    };
    return PasswordResetInitService;
}());
exports.PasswordResetInitService = PasswordResetInitService;
